export default "__VITE_PUBLIC_ASSET__11f377b8__"